import React from "react";
import { selectors } from "@ReduxStore/reducers";
import { useSelector } from "react-redux";
import MonitorUserTimeout from "./MonitorUserTimeout";

export default function UserTimeoutCheck() {
  const member = useSelector(selectors.getMember);

  // if the user isn't auth'd, no need to monitor status
  if (member.uid === null) return null;

  return <MonitorUserTimeout />;
}
